import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from 'lodash';
import { ICurrency } from "./currencies.interface";
import { UtilsService } from "../../../shared/services/utils.service";
import { apiURL, EnvConfig } from "../../../../env-config";
import { HttpService } from "../../../../http.service";

@Injectable()
export class CurrenciesService {
  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
  ) { }

  getCurrencies(filter?: any): Observable<ICurrency[]> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_CURRENCIES)}${queryParams}`);
  }

  getCurrency(currency: ICurrency | string): Observable<any> {
    let id = (typeof currency == 'string') ? currency : currency._id;
    return this._http.get(`${apiURL(EnvConfig.API_CURRENCIES)}/${id}`);
  }

  createCurrency(currency: ICurrency): Observable<any> {
    delete currency._id;
    return this._http.post(`${apiURL(EnvConfig.API_CURRENCIES)}`, currency);
  }

  updateCurrency(currency: ICurrency): Observable<any> {
    let id = currency._id;
    delete currency._id;
    return this._http.patch(`${apiURL(EnvConfig.API_CURRENCIES)}/${id}`, currency);
  }

  deleteCurrency(currency: ICurrency | string, hardDelete: boolean = false): Observable<void> {
    let id = (typeof currency == 'string') ? currency : currency._id;
    if (hardDelete) return this._http.delete(`${apiURL(EnvConfig.API_CURRENCIES)}/${id}`);
    return this._http.delete(`${apiURL(EnvConfig.API_CURRENCIES)}/${id}/delete`);
  }

  restoreCurrency(currency: ICurrency | string): Observable<void> {
    let id = (typeof currency == 'string') ? currency : currency._id;
    return this._http.post(`${apiURL(EnvConfig.API_CURRENCIES)}/${id}/restore`, null);
  }
}